import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, KeyRound, Sparkles } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const TutorLoginPage = () => {
  const navigate = useNavigate();
  const { loginTutor, user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");

  useEffect(() => {
    if (user && user.role === "tutor") {
      navigate(user.profile_complete ? "/tutor/dashboard" : "/tutor/setup", { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const result = await loginTutor(code);
      toast.success("Welcome!");
      navigate(result.profile_complete ? "/tutor/dashboard" : "/tutor/setup");
    } catch (error) {
      const msg = error.response?.data?.detail || "Invalid access code";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 text-[#4A4A4A] hover:text-[#0A0A0A] mb-8">
          <Sparkles className="w-5 h-5" />
          <span className="font-medium">Virtually Verbal</span>
        </Link>

        <div className="brutalist-card p-10">
          <div className="w-16 h-16 rounded-full bg-[#FFAEBC] border-2 border-[#0A0A0A] flex items-center justify-center mx-auto mb-6" style={{ boxShadow: '4px 4px 0px 0px rgba(10,10,10,1)' }}>
            <KeyRound className="w-8 h-8" />
          </div>
          
          <h1 className="text-3xl font-bold mb-2 text-center">Tutor Login</h1>
          <p className="text-[#4A4A4A] mb-8 text-center">Enter your access code</p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label className="text-sm font-bold uppercase tracking-wider">Access Code</Label>
              <Input
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                placeholder="XXXXXXXX"
                className="brutalist-input mt-2 text-center text-xl font-mono tracking-widest uppercase"
                maxLength={8}
                required
                data-testid="tutor-code-input"
              />
              <p className="text-xs text-[#4A4A4A] mt-2 text-center">
                Code provided by administrator
              </p>
            </div>

            <button
              type="submit"
              disabled={loading || code.length < 6}
              className="brutalist-btn-primary w-full flex items-center justify-center gap-2 disabled:opacity-50"
            >
              {loading ? <><Loader2 className="w-5 h-5 animate-spin" />Verifying...</> : "Continue"}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-[#0A0A0A]/10 text-center">
            <Link to="/login" className="text-sm text-[#4A4A4A] hover:text-[#0A0A0A]">
              Are you a student? Login here
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorLoginPage;
